"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _kernel_container_1 = __importDefault(require("../../container"));
var global_1 = require("../selectors/global");
var sendPlayState_1 = __importDefault(require("../actions/point/sendPlayState"));
function sendPlayStateSchedule(dispatch, getState) {
    var logger = _kernel_container_1.default.get("LOGGING").getLogger("@kernel/sendPlayStateSchedule");
    var state = getState();
    var lastPlayStateSend = state.global.lastPlayStateSync;
    if (lastPlayStateSend && Date.now() - lastPlayStateSend < 60 * 1000) {
        return;
    }
    if (!(0, global_1.selectIsConnected)(state)) {
        logger.debug("No internet connection, skip");
        return;
    }
    dispatch((0, sendPlayState_1.default)());
}
exports.default = sendPlayStateSchedule;
//# sourceMappingURL=sendPlayState.js.map